import { mapKeysToCamelCase } from '@skytech/utils'

import type { AssetStatus } from '@/modules/admin/resources/index'
import { API_ROUTE_ADMIN_ASSET_TYPES } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type {
  AssetStatusOriginal,
  AssetTypeOriginal,
  OwnershipTypeOriginal,
  ReturnStatusOriginal,
  UserTypeOriginal,
} from './types'

type AssetTypes = {
  ownerships: { id: number; name: OwnershipTypeOriginal; textId: string }[]
  returnStatuses: { id: number; status: ReturnStatusOriginal; description: string }[]
  statuses: { id: number; status: AssetStatusOriginal; description: string }[]
  types: { id: number; type: AssetTypeOriginal; description: string }[]
  userTypes: { id: number; type: UserTypeOriginal; description: string }[]
}

export const ONLY_LEASED_ASSET_TYPES: AssetStatus[] = ['REQ_SENT', 'CONTRACTED_EXT']
// List of unavailable asset statuses
// ID: 6, status: FURTHER_RENTAL
// ID: 9, status: REPLACED
// ID: 17, status: REMARKETED (Internal sales)
const UNAVAILABLE_STATUSES = ['FURTHER_RENTAL', 'REPLACED', 'REMARKETED']

export const getAssetTypes = async () => {
  const assetTypes = await get<AssetTypes>(API_ROUTE_ADMIN_ASSET_TYPES)
  const parsedAssetTypes = mapKeysToCamelCase(assetTypes)
  const filterAvailableStatuses = parsedAssetTypes.statuses.filter(
    ({ status }) => !UNAVAILABLE_STATUSES.includes(status)
  )

  return { ...parsedAssetTypes, statuses: filterAvailableStatuses }
}
